import React from 'react';
import { InfoIcon } from 'lucide-react';
import type { DisclosureContent } from '../../types/product';
type DisclosurePanelProps = {
  disclosure: DisclosureContent;
};
export function DisclosurePanel({
  disclosure
}: DisclosurePanelProps) {
  return <section className="w-full bg-white py-12" aria-labelledby="disclosure-heading" data-id="element-1035" data-mp="22zvd6xc8lob6">
      <div className="mx-auto max-w-shell px-6" data-id="element-1036" data-mp="280j47j0gu55e">
        <div className="rounded-[12px] border border-canvas-line p-6 sm:p-8" data-id="element-1037" data-mp="1adkb1i8zffc9">
          <h2 id="disclosure-heading" className="flex items-center gap-2 text-[14px] font-semibold text-ink" data-id="element-1038" data-mp="1abg38p7ypw6p">
            <InfoIcon className="h-4 w-4 text-ink-muted" aria-hidden="true" data-id="element-1039" data-mp="1kafac3d2xjrl" />
            {disclosure.title}
          </h2>
          <dl className="mt-5 grid grid-cols-1 gap-x-10 gap-y-4 sm:grid-cols-2" data-id="element-1040" data-mp="1p3rplmvvce7o">
            {disclosure.items.map(item => <div key={item.label} data-id="element-1041" data-mp="wlw37r5rnd13">
                <dt className="text-[12px] font-semibold text-ink" data-id="element-1042" data-mp="wl49ymzn5rdz">{item.label}</dt>
                <dd className="mt-1 text-[12px] leading-[1.6] text-ink-muted" data-id="element-1043" data-mp="2gp6imtxgzaz7">{item.value}</dd>
              </div>)}
          </dl>
          {disclosure.notes.length > 0 && <div className="mt-5 space-y-2 border-t border-canvas-line pt-4" data-id="element-1044" data-mp="26ylobiotwsm3">
              {disclosure.notes.map(note => <p key={note} className="text-[11.5px] leading-[1.6] text-ink-muted" data-id="element-1045" data-mp="22w77130t60wx">
                  {note}
                </p>)}
            </div>}
        </div>
      </div>
    </section>;
}